module.exports = __webpack_public_path__ + "img/e43.a7daeaf2.png";